// PRC-027: «Volver a …» para pantallas que no tienen «Volver» propio
// (Overview, centro de Optimización): solo aparece si se llegó con origen.
import React from 'react';
import { Button } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useBackTarget } from '../navigation';

const OriginBackLink: React.FC<{ sx?: object }> = ({ sx }) => {
  const back = useBackTarget('');
  if (!back.fromOrigin) return null;
  return (
    <Button
      size="small"
      startIcon={<ArrowBackRoundedIcon />}
      onClick={back.go}
      sx={{
        alignSelf: 'flex-start',
        minWidth: 0,
        px: 0,
        mb: 1.5,
        color: '#7dd3fc',
        textTransform: 'none',
        fontWeight: 850,
        '&:hover': { bgcolor: 'transparent', color: '#bae6fd' },
        ...sx,
      }}
    >
      {back.label}
    </Button>
  );
};

export default OriginBackLink;
